import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import TextInput from '../TextInput/TextInput';

import { authUserOperations } from '@evdy/web-redux/dist/lib/authUser';

import chevronRight from '../../public/images/chevron-right-white.svg';
import lockIcon from '../../public/images/icons/black-lock-icon.svg';

import styles from './GetMyEstimateForm.module.scss';

const { createPreneedUser, updateUserPackageInfo } = authUserOperations;

const {
  'estimate-form': estimateFormClass,
  'form-submit': formSubmitClass,
  'basic-info-form-container': basicInfoFormContainerClass,
  'name-inputs': nameInputsClass,
  'email-input': emailInputClass,
  'lock-copy': lockCopyClass,
  terms: termsClass
} = styles;

const GetMyEstimateForm = ({ preneedPackages, isLoggedIn, userData, location }) => {
  const dispatch = useDispatch();
  const {
    _id: userId,
    name,
    email,
    phone,
    meta = {},
    address,
    dateOfBirth,
    preneed
  } = userData ?? {};
  const { webLeadEmail = '' } = meta;
  const { name: preneedName, email: preneedEmail } = preneed?.userInfo ?? {};
  // query params
  const { name: queryName, email: queryEmail, fn: queryFn, ln: queryLn } = location?.query || {};
  let queryFirstName = '';
  let queryLastName = '';
  // possible params could include name, fn, ln, email
  if (queryName) {
    queryFirstName = queryName.split(' ')[0];
    queryLastName = queryName.split(' ').slice(1).join('');
  } else if (queryFn || queryLn) {
    queryFirstName = queryFn;
    queryLastName = queryLn;
  }

  const initialFormData = {
    firstName: name?.first || preneedName?.first || queryFirstName,
    lastName: name?.last || preneedName?.last || queryLastName,
    // selectedPackage: '',
    email: email || webLeadEmail || preneedEmail || queryEmail || ''
  };

  const emailRegex = /^\S+@\S+\.\S+$/;
  const estimateFormSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string()
      .matches(emailRegex, 'Please provide a valid email')
      .required('Email is required')
  });

  const handleSubmit = values => {
    if (!userId) {
      dispatch(createPreneedUser(values));
    } else {
      const userInfo = {
        name: {
          first: values.firstName,
          last: values.lastName
        },
        email,
        ...(phone && { phone }),
        ...(dateOfBirth && { dateOfBirth }),
        ...(address && { address })
      };
      dispatch(updateUserPackageInfo({ userInfo }));
    }
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialFormData}
      validationSchema={estimateFormSchema}
      enableReinitialize
      validateOnMount
    >
      {({ values, isValid }) => (
        <Form className={estimateFormClass}>
          <div className={basicInfoFormContainerClass}>
            <div className={nameInputsClass}>
              <TextInput autoFocus type="text" label="First Name" name="firstName" />
              <TextInput type="text" label="Last Name" name="lastName" />
            </div>
            <div className={emailInputClass}>
              <TextInput
                type="email"
                label="Email"
                name="email"
                placeholder="e.g. name@everdays.com"
              />
            </div>
            <div className={lockCopyClass}>
              <img src={lockIcon} alt="" />
              <p>Your information is held on a secure server and never shared</p>
            </div>
          </div>
          <button disabled={!isValid} className={formSubmitClass} type="submit">
            Get My Price
            <img src={chevronRight} alt="chev-right" />
          </button>
          <p className={termsClass}>
            By continuing you agree to the{' '}
            <a href="https://everdays.com/terms" rel="noreferrer noopener" target="_blank">
              terms and conditions
            </a>
          </p>
        </Form>
      )}
    </Formik>
  );
};

export default GetMyEstimateForm;
